import React, { useEffect, useRef, useState } from 'react';
import styles from './DarkGlowTracker.module.css';

export default function DarkGlowTracker() {
  const canvasRef = useRef(null);
  const [mouse, setMouse] = useState({ x: -1000, y: -1000 });
  const [isDark, setIsDark] = useState(false);
  
  const opacityRef = useRef(0);
  const easedMouseRef = useRef({ x: -1000, y: -1000 });
  const particlesRef = useRef([]); 

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animationFrameId;

    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      
      
      generateStaticParticles();
    };

    const generateStaticParticles = () => {
      const particleCount = 45;
      const arr = [];
      for (let i = 0; i < particleCount; i++) {
        arr.push({
          x: Math.random() * window.innerWidth,
          y: Math.random() * window.innerHeight,
          radius: Math.random() * 1.3 + 0.5,
          baseAlpha: Math.random() * 0.35 + 0.15,
          pulseOffset: Math.random() * Math.PI * 2
        });
      }
      particlesRef.current = arr;
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    const handleMouseMove = (e) => {
      const { clientX, clientY } = e;
      setMouse({ x: clientX, y: clientY });

      const hoveredElement = document.elementFromPoint(clientX, clientY);
      if (hoveredElement) {
        const insideDarkSection = 
          hoveredElement.closest('[class*="darkSection"]') || 
          hoveredElement.closest('[class*="header"]') || 
          hoveredElement.closest('[class*="bannerText"]') ||
          hoveredElement.closest('[class*="heroBanner"]');
        
        setIsDark(!!insideDarkSection);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);


    let internalClock = 0;

    const render = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);


      const targetOpacity = isDark ? 1 : 0;
      opacityRef.current += (targetOpacity - opacityRef.current) * 0.08;

      if (easedMouseRef.current.x === -1000) {
        easedMouseRef.current = { x: mouse.x, y: mouse.y };
      }


      easedMouseRef.current.x += (mouse.x - easedMouseRef.current.x) * 0.05;
      easedMouseRef.current.y += (mouse.y - easedMouseRef.current.y) * 0.05;

      const em = easedMouseRef.current;

      if (opacityRef.current > 0.01) {

        const gradientRadius = 380; 
        const glowGradient = ctx.createRadialGradient(
          em.x, em.y, 0,
          em.x, em.y, gradientRadius
        );
        
        glowGradient.addColorStop(0, `rgba(255, 60, 33, ${0.18 * opacityRef.current})`);
        glowGradient.addColorStop(0.3, `rgba(224, 32, 32, ${0.07 * opacityRef.current})`);
        glowGradient.addColorStop(0.7, `rgba(224, 32, 32, ${0.015 * opacityRef.current})`);
        glowGradient.addColorStop(1, 'transparent');

        ctx.fillStyle = glowGradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

   
        internalClock += 0.002; 

        particlesRef.current.forEach((p) => {
          const dx = em.x - p.x;
          const dy = em.y - p.y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          

          let pulseAlpha = p.baseAlpha + Math.sin(internalClock + p.pulseOffset) * 0.05;
          let currentAlpha = pulseAlpha * opacityRef.current;

          if (dist < 160) {
    
            currentAlpha += (1 - dist / 160) * 0.25 * opacityRef.current;
          }


          ctx.beginPath();
          ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(255, 95, 75, ${Math.min(currentAlpha, 0.9)})`;
          

          if (dist < 100) {
            ctx.shadowBlur = 6;
            ctx.shadowColor = '#ff3c3c';
          }
          
          ctx.fill();
          ctx.shadowBlur = 0; 
        });
      }

      animationFrameId = requestAnimationFrame(render);
    };

    render();

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('mousemove', handleMouseMove);
      cancelAnimationFrame(animationFrameId);
    };
  }, [isDark, mouse]);

  return <canvas ref={canvasRef} className={styles.canvas} aria-hidden="true" />;
}